import type { HITLState } from './sessionModel'

export type QueuedHitl = { hitl: HITLState; nonce: string }

/**
 * Remove one terminal AskUserQuestion and, when it was visible, promote the
 * next prompt for the current session. Prompts from background sessions stay
 * queued until that session becomes visible.
 */
export function resolveHitlPrompt(
  active: HITLState | null,
  queue: QueuedHitl[],
  askId: string,
  currentSessionId: string | undefined,
): { active: HITLState | null; queue: QueuedHitl[] } {
  const remaining = queue.filter(({ hitl }) => hitl.runId !== askId)
  if (active?.runId !== askId) return { active, queue: remaining }

  const nextIndex = currentSessionId
    ? remaining.findIndex(({ hitl }) => hitl.sessionId === currentSessionId)
    : -1
  if (nextIndex < 0) return { active: null, queue: remaining }

  const next = remaining[nextIndex]!.hitl
  return {
    active: next,
    queue: remaining.filter((_, index) => index !== nextIndex),
  }
}
